import { render, staticRenderFns } from "./addArea.vue?vue&type=template&id=4d95c830&scoped=true"
import script from "./addArea.vue?vue&type=script&lang=js"
export * from "./addArea.vue?vue&type=script&lang=js"
import style0 from "./addArea.vue?vue&type=style&index=0&id=4d95c830&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95c830",
  null
  
)

export default component.exports